

import {ID, ListRequest} from "../../../types/global.d";
import {displayTime, displayDate, displayDateTime} from "../../../utils/formatDate";
import {OrderBy} from "../../../types/global.d";

// Interface for entity Locations


export interface Location {
    id: ID;

    
    name: string;

    
    description?: string;

    
    hierarchyName: string;

    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    note?: string;

    
    parentId?: ID;

    
    scopeGroupId: ID;

    }

export interface FilterAdvancedPresentationRequest {
    list: ListRequest,
    filter: {
        
            name?: string,
        
    
    

            hierarchyName?: string,
        
    
    

            parentId: ID[],
        
    
    parentIdInclude: boolean,



        parentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}



export interface CreateLocation {
    
    name: string;

    
    description?: string;

    
    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    note?: string;

    
    parentId?: ID;

    
    }


export interface UpdateLocation {
    
    name: string;

    
    description?: string;

    
    
    address?: string;

    
    city?: string;

    
    country?: string;

    
    note?: string;

    
    
    }

export interface PresentationLocationRequest {
    list: ListRequest,
    filter: {
        hierarchyName: string,
        hierarchyNameOr: boolean,
        parentIdRefs?: ID[],
        orderBys: OrderBy[],
        caseSensitive: boolean,
    },
}

export class PrimaryLocation {
    id: string;


    constructor(
        id: ID,
        ) {
        this.id = id?.toString();
        }

    static fromEntity(entity: Location): PrimaryLocation | undefined {
        return entity ? new PrimaryLocation(
            entity.id,
        ) : undefined;
    }

    static fromId(id: ID
): PrimaryLocation {
        return new PrimaryLocation(
                id,
                );
    }
    
    static fromPath(path?: string): PrimaryLocation {
        let vals = path?.split('/');
        return new PrimaryLocation(
                   vals[0],
                );
    }

    static fromQuery(value?: string): number | undefined {
        return value ? value : undefined
    }

    toPath(): string {
        let ids = [
            this.id,
            ];
        return ids.join('/');
    }

    static toQueryParams(ids: PrimaryLocation[]): string {
        return '?ids=' + ids.map(id => id.id).join('&ids=');
    }
}

export function toString(entity?: Location): string {
    let fields = entity ? [
    entity.hierarchyName,
            ] : [];
    return fields.filter(item => item).join(' | ');
}

export class UpdateEntityLocation {
    id: PrimaryLocation;
    data: UpdateLocation;


    constructor(id: PrimaryLocation, data: UpdateLocation) {
        this.id = id;
        this.data = data;
    }
}
